export function asideFilter() {
    let btn = $(".filter-heading .expand-btn");
    let wrapper = $(".filters-wrapper");

    btn.on("click", function (event) {
        event.preventDefault();
        $(this).parent().toggleClass("expanded");
        wrapper.slideToggle(300);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/aside-filter-expand.js